import { useEffect, useRef, useState } from "react";
import { distributorDesignList } from "../../redux/features/distributoreCatalogue/distributoreCatalogue";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { useParams } from "react-router-dom";
import { DistributoreCategoryFilter } from "../../container/DistributorCategoryFiltes";
import DistributorCardComponent from "../../components/DistributorCardComponent";
import { nanoid } from "nanoid";
import InfiniteScroll from "react-infinite-scroll-component";
import jewelLoder from "../../assets/Logo/logo 2.png";
import TagComponent from "../../components/TagComponent";
import ModalComponent from "../../components/ModalComponent";
import DistibutorFilterForm from "../../container/DistibutorFilterForm";
import { getAllCart } from "../../redux/features/distributoreCart/distributoreCart";
import DistributorCartButton from "../../components/DistributorCartButton";
import { DistributorKaratFilter } from "../../container/DistributorKaratFilter";

type Props = {};

const DistributorCatalogue = (props: Props) => {
  const dispatch = useAppDispatch();
  const ModalRef = useRef<HTMLDivElement | null>(null);
  const [filterView, setfilterView] = useState<boolean>(false);
  const karat = useAppSelector((state) => state.distributoreCatalogue.karat);
  const categoryIds = useAppSelector((state) => state.distributoreCatalogue.categoryIds);
  const catalugeName = useAppSelector((state) => state.distributoreCatalogue.catalaugename);
  const catalugeitemes = useAppSelector((state) => state.distributoreCatalogue.catalugeitemes);
  const page = useAppSelector((state) => state.distributoreCatalogue.page);
  const distributorDesing = useAppSelector((state) => state.distributoreCatalogue.rows);
  const hasmore = useAppSelector((state) => state.distributoreCatalogue.hasmore);
  const CategoryList = useAppSelector((state) => state.distributoreCatalogue.category);
  const searchFilter = useAppSelector((state) => state.distributoreCatalogue.searchFilter);

  const { id } = useParams();

  const fetchMore = async () => {
    if (categoryIds.length !== 0) {
      dispatch(
        distributorDesignList({
          payload: {
            page: page + 1,
            karat: karat,
            categoryList: categoryIds,
            distributor_catalogue_id: id,
          },
          isInfiniteScroll: true,
        })
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getAllCart());
  }, []);

  useEffect(() => {
    if (categoryIds.length !== 0) {
      if (searchFilter === "") {
        dispatch(
          distributorDesignList({
            payload: {
              page: 1,
              karat: karat,
              categoryList: categoryIds,
              distributor_catalogue_id: id,
            },
            isInfiniteScroll: false,
          })
        );
      }
    }
  }, [karat, categoryIds, searchFilter]);

  return (
    <>
      {filterView ? (
        <ModalComponent setShow={setfilterView} show={filterView}>
          <DistibutorFilterForm ref={ModalRef} closeForm={setfilterView} />
        </ModalComponent>
      ) : null}
      <div className="container">
        <div className="min-h-fit">
          <div className="flex my-[30px] justify-between">
            <div className="title">
              <h4 className="text-xl md:text-2xl text-primary font-bold">{catalugeName}</h4>
              <h6 className="text-primary">Total {catalugeitemes} items</h6>
            </div>
            <DistributorCartButton />
          </div>
          <div className="flex sm:hidden gap-3 flex-row overflow-auto hide-scroll w-32 ">
            <TagComponent
              icon="/icons8-filter-24.png"
              CTA="Filter"
              onClick={() => {
                setfilterView(true);
              }}
            />
            {/* <TagComponent
              CTA="All"
              onClick={() => {
                setfilterView(true);
              }}
            />
            {CategoryList.map((i) => (
              <TagComponent
                CTA={i.name}
                onClick={() => {
                  setfilterView(true);
                }}
                key={nanoid()}
              />
            ))} */}
          </div>
          <div className="grid grid-cols-12 gap-2">
            <div className="hidden lg:block col-span-2">
              <div className="shadow-menu  rounded-[10px] ">
                <div className="p-8">
                  <h3 className="text-base font-bold">Categories</h3>
                  <ul className="cursor-pointer pt-5">
                    <DistributoreCategoryFilter />
                  </ul>
                </div>
              </div>
              <div className="shadow-menu my-[30px] rounded-[10px]">
                <div className="p-8 ">
                  <h3 className="text-base font-bold">Karat</h3>
                  <DistributorKaratFilter />
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-10 ">
              <InfiniteScroll
                className="col-span-12 lg:col-span-10 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-7"
                dataLength={distributorDesing?.length}
                hasMore={hasmore}
                loader={
                  <>
                    <img className="" src={jewelLoder} alt="loader" />
                  </>
                }
                next={() => {
                  fetchMore();
                }}
              >
                {distributorDesing.map((i) => (
                  <div className="col-span-1" key={nanoid()}>
                    <DistributorCardComponent
                      cartDetails={i.CartDesignInfo}
                      link={`/distributor/${id}/${i?.variant_number}/${i.id}`}
                      net_weight={i.net_weight}
                      img={i.designs.image_files[0].ImageURL}
                      varient={i?.variant_number}
                      available_stock={i.available_stock}
                      categoryId={i.id}
                      Karat={i.karat}
                      isSoldOut={i.is_sold}
                    />
                  </div>
                ))}
              </InfiniteScroll>
              {distributorDesing.length === 0 && <p className="text-center font-bold">No Design available</p>}
            </div>
          </div>
          <div className="footer"></div>
        </div>
      </div>
    </>
  );
};

export default DistributorCatalogue;
